import { HomeIcon } from "lucide-react"
import { Link } from "react-router-dom"
import { Button } from "@/components/ui/button"
import { AstronautIcon } from "@/components/ui/icons/AstronautIcon"

const NotFoundPage = () => {
  return (
    <div className="flex h-full grow flex-col items-center justify-center gap-8">
      <AstronautIcon height="300px" width="100%" />

      <h1 className="text-4xl font-semibold">Página no encontrada</h1>

      <div>
        <Button variant="default" size="lg" asChild>
          <Link to="/">
            <HomeIcon className="mr-3" />
            <span>Volver al inicio</span>
          </Link>
        </Button>
      </div>
    </div>
  )
}

export { NotFoundPage }
